export const GEOFENCE = 'geofence'
